<template>
  <div class="login" v-if="openAppLoginStatus">
    <div class="login_bg"></div>
    <div class="login_box">
      <div class="login_colse" @click="colseLogin">
        <img
          class="login_colse_img"
          :src="require('@/img/' + getTheme + '-close.png')"
          alt=""
        />
      </div>
      <!-- <div class="login_url"> -->
      <!-- <img class="login_img" :src="evaluationState.data.icon" alt="" /> -->
      <!-- </div> -->
      <div class="login_title">{{ $t("appLogin.text") }}</div>

      <!-- <div class="login_text">
        1232
      </div> -->
      <div class="login_btn" @click="login">
        {{ $t("appLogin.login") }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
export default {
  data() {
    return {
      getTheme: "",
    };
  },
  computed: {
    ...mapState("game", ["openAppLoginStatus"]),
  },
  created() {
    this.getTheme = configs.getTheme();
  },
  mounted() {},
  methods: {
    ...mapActions("game", ["openAppLogin"]),
    ...mapActions("user", ["tipMessage", "userInfo"]),
    //获取用户信息
    async getUserInfo() {
      const res = await this.userInfo({
        $axios: this.$axios,
        lang: localStorage.getItem("lang"),
        appId: configs.bipAppId(),
        token: localStorage.getItem("Bearer"),
      });
      return;
    },

    async login() {
      if (windows.TgaBridge) {
        const res = await TgaBridge.goLogin();
        if (res) {
          this.colseLogin();
          if (res.success) {
            localStorage.setItem("Bearer", res.accessToken);
            localStorage.setItem("refreshToken", res.refreshToken);
            this.tipMessage({ context: this.$t("appLogin.loginSuccess") });
            await this.getUserInfo();
          } else {
            this.tipMessage({ context: this.$t("appLogin.loginError") });
          }
        }
      } else if (window.Bridge) {
        const res = window.Bridge.uc.login({ type: "app" });
        if (res) {
          this.colseLogin();
          if (res.success) {
            localStorage.setItem("Bearer", res.accessToken);
            localStorage.setItem("refreshToken", res.refreshToken);
            this.tipMessage({ context: this.$t("appLogin.loginSuccess") });
            await this.getUserInfo();
          } else {
            this.tipMessage({ context: this.$t("appLogin.loginError") });
          }
        }
      }
    },
    colseLogin() {
      this.openAppLogin({
        $axios: this.$axios,
        status: false,
      });
    },
  },
};
</script>
<style scoped="scoped">
.login {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.login_box {
  position: relative;
  z-index: 2;
  width: 7.6rem;
  height: 5.7rem;
  background-color: var(--loginModelBg);
  border-radius: 0.45rem;
}
.login_colse {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.29rem 0.24rem;
}
.login_colse_img {
  width: 0.73rem;
  height: 0.73rem;
}
.login_url {
  position: relative;
  width: 2.18rem;
  height: 2.18rem;
  margin: 0.66rem auto 0;
}
.login_img {
  box-sizing: border-box;
  object-fit: cover;
  width: 2.18rem;
  height: 2.18rem;
  border-radius: 0.2rem;
  border: 0.06rem solid #ffffff;
  box-shadow: 0px 0.07rem 0.15rem 0px rgba(0, 0, 0, 0.2);
}
.login_title {
  margin: 1.9rem auto 0;
  width: 80%;
  /* margin-top: 0.3rem; */
  text-align: center;
  font-size: 0.5rem;
  color: var(--loginModelcolor);
}
.login_text {
  margin-top: 0.4rem;
  font-size: 0.5rem;
  color: #1d1d1d;
  padding: 0 1rem;
  text-align: center;
}
.login_btn {
  position: absolute;
  bottom: 0.5rem;
  left: 10%;
  width: 80%;
  height: 1.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.42rem;
  color: var(--loginModelbtnColor);
  background-color: var(--loginModelbtn);
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.61rem;
  margin: 1rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/model/login.vue